(function () {

    'use strict';

    angular.module('Services').service('ReportingCarrierBySpendTableService', ReportingCarrierBySpendTableService);

    function ReportingCarrierBySpendTableService($q, $filter, Shipments, Carrier, TableLiteFactory, CommonService, trackingStatusesConst, toastr) {
        var serviceDetailsList = {
            carriers: [],
            services: []
        };
        let allServices = [];

        function getCarriers() {
            Carrier.getCarriers(function (data) {
                angular.forEach(data, (carrier)=>{serviceDetailsList.carriers.push(carrier)});
            }, function (error) {
                console.log(error);
            }).getServices(function (data) {
                angular.forEach(data, (services)=>{serviceDetailsList.services.push(services)});
                allServices = angular.copy(serviceDetailsList.services);
            });
        };

        const ReportingAccountBySpendTable = {
            tableName: 'ReportingCarrierBySpendTableService',
            config: {
                noPagination: false,
                noHeaders: false,
                noItemsView: false,
                noTableFooter: false,
            },
            headers: [{
                label: 'CARRIER',
                viewName: 'titleLogo',
                filterName: 'carrierId',
                filter: {
                    type: 'select2',
                    placeholder: 'Search',
                    class: 'filter-carrier-name',
                    viewName: 'name',
                    filterBy: 'id',
                    items: serviceDetailsList.carriers, //List of items shown in dropdown
                    onSubmit: function (header) {
                        delete activeFilters.serviceId;
                        if(serviceDetailsList.serviceHeader)
                            delete serviceDetailsList.serviceHeader.filter.model;
                        sendRequest(evaluateFilter(header));
                        serviceDetailsList.services.length = 0;
                        angular.forEach(header.filter.model.services, function (service) {
                            serviceDetailsList.services.push(service);
                        });
                    }
                },
                headerFn: function () {
                    sort(this.filterName);
                }
            }, {
                label: 'Carrier Profile',
                viewName: 'carrierProfileName',
                filterName: 'carrierProfileId',
                sortName: 'carrierProfile.id',
                filter: {
                    type: 'autoComplete',
                    placeholder: 'Search',
                    viewName: 'name',
                    model: '',
                    filterBy: 'id',
                    items: [],
                    onSubmit: function (header) {
                        tableActions.sendRequest(tableActions.evaluateFilter(header));
                    },
                    refresh: function (model) {
                        const defer = $q.defer();
                        let filterItems = this.items;
                        Carrier.getExternalCarrierProfiles((data) => {
                            filterItems.length = 0;
                            angular.forEach(data.content, (profile) => {
                                filterItems.push(profile);
                            });
                            defer.resolve();
                        }, (error) => {
                            console.log(error);
                            defer.reject();
                        }, {size: 20, name: model});
                        return defer.promise;
                    }
                },
                headerFn: function () {
                    sort(this.filterName);
                }
            }, {
                label: 'MONTH',
                viewName: 'amountMonth',
                filterName: 'amountMonth',
                /*filter: {
                    type: 'inputDropdown',
                    class: 'bba-ref-no',
                    placeholder: 'Search',
                    items: [{
                        viewName: 'Month 1'
                    }, {
                        viewName: 'Month 2'
                    }],
                    onSubmit: function () {
                        console.log(this);
                    }
                },*/
                headerFn: function () {
                    sort(this.filterName);
                }
            }, {
                label: 'MONTH LAST YEAR',
                viewName: 'comparableMonthLastYear',
                filterName: 'comparableMonthLastYear',
                /*filter: {
                    type: 'text',
                    class: 'bba-ref-no',
                    placeholder: 'Search',
                    onSubmit: function () {
                        console.log(this);
                    }
                },*/
                headerFn: function () {
                    sort(this.filterName);
                }
            }, {
                label: 'YEAR',
                viewName: 'amountYear',
                filterName: 'amountYear',
                /*filter: {
                    type: 'inputDropdown',
                    class: 'bba-ref-no',
                    placeholder: 'Search',
                    items: [{
                        viewName: 'Test'
                    }, {
                        viewName: 'Test2'
                    }],
                    onSubmit: function () {
                        console.log(this);
                    }
                },*/
                headerFn: function () {
                    sort(this.filterName);
                }
            }, {
                label: 'LAST YEAR',
                viewName: 'comparableYear',
                filterName: 'comparableYear',
                /*filter: {
                    type: 'inputDropdown',
                    class: 'bba-ref-no',
                    placeholder: 'Search',
                    items: [{
                        viewName: 'Test'
                    }, {
                        viewName: 'Test2'
                    }],
                    onSubmit: function () {
                        console.log(this);
                    }
                },*/
                headerFn: function () {
                    sort(this.filterName);
                }
            }],
            data: [],
            resetFilters: resetFilters
        };
        const tableActions = new TableLiteFactory(ReportingAccountBySpendTable,
            {
                serviceCallback: Shipments.getCarrierBySpend,
                callbackFormat: ['success','error','filter'],
                postRequestCallback: data => {
                    buildTableData(data);
                },
                postRequestErrorCallback: err => {
                    buildTableData(null);
                    toastr.error(err);
                },
                defaultFilters : {
                    size: 20,
                    page: 0,
                    sort: 'id,desc'
                }
            }
        );
        const sort = tableActions.sort;
        const evaluateFilter = tableActions.evaluateFilter;
        const sendRequest = tableActions.sendRequest;
        const activeFilters = tableActions.activeFilters;
        function resetFilters() {
            angular.forEach(ReportingAccountBySpendTable.headers, function (header) {
                if (header.filter) {
                    if (header.filter.model)
                        header.filter.model = '';
                    if (header.filter.toModel)
                        header.filter.toModel = '';
                    if (header.filter.fromModel)
                        header.filter.fromModel = '';
                    delete activeFilters[header.filterName];
                }
            });
            serviceDetailsList.services.length = 0;
            angular.forEach(allServices, function (service) {
                serviceDetailsList.services.push(service);
            });
            sendRequest({});
        }

        function buildTableData(data) {
            /*** START - Building of Data ***/
            tableActions.initializeTableData(data);
            angular.forEach(data.content, function (val) {
                if(!serviceDetailsList.carriers.length) {
                    getCarriers();
                }

                val.titleLogo = {
                    type: 'logotype',
                    imgSrc: CommonService.isContainLogo(val.carrierProfile ? val.carrierProfile : val)
                };
                val.comparableMonthLastYear = $filter('bbaCurrency')(val.comparableMonthLastYear , val.currency);
                val.amountMonth = $filter('bbaCurrency')(val.amountMonth , val.currency);
                val.amountYear = $filter('bbaCurrency')(val.amountYear , val.currency);
                val.comparableYear = $filter('bbaCurrency')(val.comparableYear , val.currency);
                val.carrierProfileName = angular.getObjVal(val, 'carrierProfile.name') || 'N/A';
                //val.href = '/reporting/service-by-spend?carrierId=' + val.carrierId + "&carrierName=" + val.carrierName;

                ReportingAccountBySpendTable.data.push(val);
            })
        };
        return ReportingAccountBySpendTable;
    };
})();



// WEBPACK FOOTER //
// ./js/services/tables/ReportingCarrierBySpendTableService.js